@use "~theme/typography";

.container {
  position: relative;
  display: inline-block;
}

.tooltipContainer {
  background-color: var(--blue-02);
  color: var(--white);
  border-radius: 4px;
  visibility: hidden;
  position: absolute;
  z-index: var(--float);
  width: 300px;
  padding: 4px 8px;
}

.tooltipContainerNew {
  background-color: white;
  color: black;
  border-radius: 4px;
  visibility: hidden;
  position: absolute;
  z-index: var(--float);
  width: 300px;
  padding: 4px 8px;
  border: 1px solid var(--blue-00);

  p {
    color: var(--pure-black);
    text-align: center;
    /* Body/--font-size-body-small: 14px */
    font-family: "Avenir Next";
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 140%; /* 19.6px */
    margin: 0px;
    padding: 0px;
  }
}

.tooltipContainer p {
  @include typography.body;
  margin-top: 0;
}

.tooltipContainer p:last-child {
  margin-bottom: 0;
}

.tooltipPositionTop, .tooltipPositionTopnew {
  bottom: 100%;
  left: 90%;
  margin-left: calc(300px * -0.9);
  margin-bottom: 8px;
}

.tooltipPositionTop::after {
  content: " ";
  position: absolute;
  top: 100%; /* At the bottom of the tooltip */
  left: calc(90% - 10px);
  margin-left: -8px;
  border-width: 8px;
  border-style: solid;
  border-color: var(--blue-02) transparent transparent transparent;
}

.tooltipPositionTopnew::after {
  content: " ";
  position: absolute;
  top: 100%; /* At the bottom of the tooltip */
  left: calc(90% - 10px);
  margin-left: -8px;
  border-width: 8px;
  border-style: solid;
  border-color: white transparent transparent transparent;
}

.tooltipVisible {
  visibility: visible;
}

.content {
  padding: 12px;
}

.contentNew {
  padding: 0px;
}

.contentContainer {
  display: flex;
  flex-direction: row;
}

.buttonIcon {
  border: none;
  outline: none;
  padding: 0;
  font: inherit;
  color: inherit;
  background-color: transparent;
  cursor: pointer;
}
